import { render, staticRenderFns } from "./planDetail.vue?vue&type=template&id=0151a454&scoped=true&"
import script from "./planDetail.vue?vue&type=script&lang=js&"
export * from "./planDetail.vue?vue&type=script&lang=js&"
import style0 from "./planDetail.vue?vue&type=style&index=0&id=0151a454&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0151a454",
  null
  
)

export default component.exports